import { createElement } from 'react';
import './index.scss';
const ColorfulCrumb = function ColorfulCrumb({ sign, list, ...otherProps }) {
    const _otherProps = otherProps || {};
    const defaultSource = [
        { icon: '', title: '首页' },
        { icon: '', title: '目录二' },
    ];
    const data = list.length ? list : defaultSource;
    return (createElement("div", { className: `au-crumb`, ..._otherProps }, data?.map((_, index) => {
        if (_ === undefined)
            return null;
        return (createElement("label", { className: `au-crumb-box` },
            createElement("span", { className: "au-crumb-line" }, sign || '/'),
            createElement("a", { href: "javascript:", className: "au-crumb-link" },
                createElement("i", { className: _.icon ? _.icon : ' ' }),
                createElement("span", null, _.title))));
    })));
};
ColorfulCrumb.displayName = 'ColorfulCrumb';
export default ColorfulCrumb;
